import { render, staticRenderFns } from "./FeaturedAdd.vue?vue&type=template&id=2137cda0&scoped=true&"
import script from "./FeaturedAdd.vue?vue&type=script&lang=js&"
export * from "./FeaturedAdd.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedAdd.vue?vue&type=style&index=0&id=2137cda0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137cda0",
  null
  
)

export default component.exports